import { useRef } from "react";
import { useTabsContext } from "../../context/TabsContext";

/**
 * @param {Object} props
 * @param {string} props.value - Must match the corresponding Tab's value.
 * @param {boolean} [props.forceMount] - Render even before first activation (kept in DOM, just hidden).
 */
const TabPanel = ({
  value,
  forceMount = false,
  children,
  className = "",
  ...rest
}) => {
  const { activeValue } = useTabsContext("TabPanel");
  const isActive = activeValue === value;
  const hasBeenActive = useRef(isActive);
  if (isActive) hasBeenActive.current = true;
  else hasBeenActive.current = false;

  if (!isActive && !forceMount && !hasBeenActive.current) {
    return null; // Lazy mount: never rendered until first activated.
  }

  return (
    <div
      role="tabpanel"
      id={`panel-${value}`}
      aria-labelledby={`tab-${value}`}
      hidden={!isActive}
      tabIndex={0}
      className={`tabs-panel ${className}`}
      {...rest}
    >
      {isActive || forceMount || hasBeenActive.current ? children : null}
    </div>
  );
};

export default TabPanel;
